module.exports = __webpack_public_path__ + "img/media-success.b03eda6a.png";